import {useMemo} from 'react';
export const usePixelIconSrc = (url: string) => {
  return useMemo(() => {
    const urlBase = url.split('?')[0] ?? url;
    const imageParams = new URLSearchParams();

    // use max Size of Icons as default Size for Image. Multiply by two to be safe with High Resolution displays
    imageParams.set('height', '180');
    imageParams.set('width', '180');

    return `${urlBase}?${imageParams.toString()}`;
  }, [url]);
};
